import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'
import { Button } from 'components/atoms/button'

interface DeleteEventModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm: () => void
}

export function DeleteEventModal({ open, setOpen, onConfirm }: DeleteEventModalProps) {
	return (
		<ConfirmationModal title="Delete Event" open={open} setOpen={setOpen} blur>
			<div>
				<div className="mb-8">Are you sure, you want to delete this event?</div>
				<div className="space-y-2">
					<Button variant="secondary" fullWidth onClick={onConfirm}>
						Yes
					</Button>
					<Button variant="secondary" fullWidth onClick={() => setOpen(false)}>
						Cancel
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface DeleteEventModalManagedProps {
	onConfirm: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'delete-event': DeleteEventModalManagedProps
	}
}

export function ManagedDeleteEventModal({
	onClose,
	onConfirm,
}: DeleteEventModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<DeleteEventModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm(); handleClose() }}
		/>
	)
}
